import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulk-download',
  templateUrl: './bulk-download.component.html',
  styleUrls: ['./bulk-download.component.scss']
})
export class BulkDownloadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
